import React from 'react';
import { Link } from 'react-router-dom';

const NotFoundPage = () => {
  return (
    <div className="flex items-center justify-center h-screen bg-gray-100">
      <div className="text-center">
        <h1 className="text-9xl font-bold text-[#ED5150]">404</h1>
        <p className="text-xl mt-4 mb-8 text-gray-600">Looks like this page doesn't exist!</p>
        <Link
          to="/"
          className="px-6 py-3 text-white bg-[#730000] rounded-lg focus:outline-none"
        >
          Back to Home
        </Link>
      </div>
    </div>
  );
};

export default NotFoundPage;